import { render } from "./CodeSandbox.vue?vue&type=template&id=53aed325"
import script from "./CodeSandbox.vue?vue&type=script&lang=js"
export * from "./CodeSandbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/hoxer/Dokumenter/GitHub/techecute/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__